/**
 * Google Calendar feature
 */

export const MESSAGE_GOOGLE_CALENDAR_FEATURE =
  "message-google-calendar-feature";
